module.exports = __webpack_public_path__ + "img/a5-s19.315183ee.jpg";